import { default as employeeHealthInfoTypes } from "./types";

const {
  FETCH_EMPLOYEE_HEALTH_INFO_REQUEST,
  FETCH_EMPLOYEE_HEALTH_INFO_SUCCESS,
  FETCH_EMPLOYEE_HEALTH_INFO_FAILURE,
  ADD_EMPLOYEE_HEALTH_INFO_REQUEST,
  ADD_EMPLOYEE_HEALTH_INFO_SUCCESS,
  ADD_EMPLOYEE_HEALTH_INFO_FAILURE,
  EDIT_EMPLOYEE_HEALTH_INFO_REQUEST,
  EDIT_EMPLOYEE_HEALTH_INFO_SUCCESS,
  EDIT_EMPLOYEE_HEALTH_INFO_FAILURE,
  DELETE_EMPLOYEE_HEALTH_INFO_REQUEST,
  DELETE_EMPLOYEE_HEALTH_INFO_SUCCESS,
  DELETE_EMPLOYEE_HEALTH_INFO_FAILURE,
} = employeeHealthInfoTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEE_HEALTH_INFO_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_EMPLOYEE_HEALTH_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_EMPLOYEE_HEALTH_INFO_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    case ADD_EMPLOYEE_HEALTH_INFO_REQUEST:
    case EDIT_EMPLOYEE_HEALTH_INFO_REQUEST:
    case DELETE_EMPLOYEE_HEALTH_INFO_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_EMPLOYEE_HEALTH_INFO_SUCCESS:
    case EDIT_EMPLOYEE_HEALTH_INFO_SUCCESS:
    case DELETE_EMPLOYEE_HEALTH_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case ADD_EMPLOYEE_HEALTH_INFO_FAILURE:
    case EDIT_EMPLOYEE_HEALTH_INFO_FAILURE:
    case DELETE_EMPLOYEE_HEALTH_INFO_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
